import { useSalesLocale } from '../../locale';

import React from 'react';
import { Form, Modal, Switch } from 'antd';
import type { NotificationPreferences } from '../../services/phase5/notificationCenter';

interface NotificationPreferencesModalProps {
  open: boolean;
  zIndex?: number;
  getContainer?: () => HTMLElement;
  value: NotificationPreferences;
  saving?: boolean;
  onCancel: () => void;
  onSave: (next: NotificationPreferences) => void;
}

export const NotificationPreferencesModal: React.FC<NotificationPreferencesModalProps> = ({
  open,
  zIndex,
  getContainer,
  value,
  saving,
  onCancel,
  onSave,
}) => {
  const { t: salesText } = useSalesLocale();

  const [state, setState] = React.useState<NotificationPreferences>(value);

  React.useEffect(() => {
    setState(value);
  }, [value, open]);

  return (
    <Modal
      zIndex={zIndex}
      getContainer={getContainer}
      title={salesText("Notification Preferences")}
      open={open}
      onCancel={onCancel}
      onOk={() => onSave(state)}
      okButtonProps={{ loading: saving }}
    >
      <Form layout="vertical">
        <Form.Item label={salesText("Enable browser notifications")}>
          <Switch
            aria-label={salesText("Enable browser notifications")}
            checked={state.enableBrowserNotifications}
            onChange={(checked) => setState((prev) => ({ ...prev, enableBrowserNotifications: checked }))}
          />
        </Form.Item>
        <Form.Item label={salesText("Follow-up reminders")}>
          <Switch aria-label={salesText("Follow-up reminders")} checked={state.followupReminders} onChange={(checked) => setState((prev) => ({ ...prev, followupReminders: checked }))} />
        </Form.Item>
        <Form.Item label={salesText("New lead assigned")}>
          <Switch aria-label={salesText("New lead assigned")} checked={state.newLeadAssigned} onChange={(checked) => setState((prev) => ({ ...prev, newLeadAssigned: checked }))} />
        </Form.Item>
        <Form.Item label={salesText("Transfer request updates")}>
          <Switch aria-label={salesText("Transfer request updates")} checked={state.transferRequestUpdates} onChange={(checked) => setState((prev) => ({ ...prev, transferRequestUpdates: checked }))} />
        </Form.Item>
        <Form.Item label={salesText("Need review updates")}>
          <Switch aria-label={salesText("Need review updates")} checked={state.needReviewUpdates} onChange={(checked) => setState((prev) => ({ ...prev, needReviewUpdates: checked }))} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
